export default __webpack_public_path__ + "static/media/Ies_Current.ff9b3382.png";